import { makeStyles } from 'tss-react/mui';

import { styleCondition } from '../../../utils/styleCondition';

export const useStyles = makeStyles()(
  (theme, { isUnavailableForOrder } = {}) => ({
    root: {
      position: 'relative',
      borderRadius: 20,
      boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
      display: 'flex',
      flexDirection: 'column',
      height: 495,
      [theme.breakpoints.down('lg')]: {
        height: 380,
      },
      [theme.breakpoints.down('md')]: {
        borderRadius: 10,
        height: 275,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: 380,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          borderRadius: 10,
          height: 275,
        }),
      },
    },
    img: {
      ...(isUnavailableForOrder && {
        opacity: 0.65,
      }),
    },
    actionArea: {
      position: 'relative',
      width: 'initial',
    },
    description: {
      cursor: 'pointer',
      display: '-webkit-box',
      fontSize: 18,
      lineHeight: '20px',
      fontWeight: 700,
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('lg')]: {
        fontSize: 14,
        lineHeight: '14px',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        marginBottom: 0,
        lineHeight: '12px',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 14,
          lineHeight: '14px',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
          marginBottom: 0,
          lineHeight: '12px',
        }),
      },
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      padding: '14px 20px !important',
      height: '100%',
      minWidth: 50,
      flex: 1,
      [theme.breakpoints.down('lg')]: {
        padding: '10px !important',
      },
      [theme.breakpoints.down('md')]: {
        padding: '8px !important',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          padding: '10px !important',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          padding: '8px !important',
        }),
      },
    },
    sizeVers: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
      [theme.breakpoints.downLandscape('sm')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 10,
        }),
      },
    },
    flagButton: {
      marginLeft: 'auto',
    },
    stockItem: {
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 10,
        }),
      },
    },
    fdmButton: {
      alignSelf: 'start',
      fontSize: 12,
      padding: theme.spacing(1),
      width: 105,
      [theme.breakpoints.down('lg')]: {
        alignSelf: 'start',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          alignSelf: 'start',
        }),
      },
    },
    removeButton: {
      fontSize: 22,
      position: 'absolute',
      right: '10px',
      top: '10px',
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 14,
        }),
      },
    },
    materialsQtyButtons: {
      width: '100%',
    },
    kitsQtyButtons: {
      width: '100%',
    },
    laterQtyButtons: {
      width: '100%',
    },
    labels: {
      display: 'flex',
      columnGap: theme.spacing(1),
      position: 'absolute',
      left: theme.spacing(2),
      top: theme.spacing(2),
      zIndex: 10,
      [theme.breakpoints.down('md')]: {
        columnGap: theme.spacing(0.75),
        left: theme.spacing(1.25),
        top: theme.spacing(1.25),
      },
    },
  }),
);
